import assign from 'object-assign';
import * as types from '../actions/ActionTypes';
import initialState from './initialState';

export default function productReducer(
    state: any = initialState.productsResult,
    action: { type: string; productsResult: any }
) {
    switch (action.type) {
        case types.LOAD_PRODUCTS_SUCCESS:
            return action.productsResult;
        case types.CREATE_PRODUCT_SUCCESS:
            return {
                products: [...state.products, assign({}, action.productsResult)],
                productTypes: state.productTypes,
                productDeliveryTimes: state.productDeliveryTimes,
                properties: state.properties,
                bookingConditions: state.bookingConditions,
                legalEntities: state.legalEntities,
                sites: state.sites,
                invoiceProductTypes: state.invoiceProductTypes
            };
        case types.EDIT_PRODUCT_SUCCESS:
            let products = assign([], state.products);
            let productIndex = products.findIndex((x: any) => {
                return x.id === action.productsResult.id;
            });

            products.splice(productIndex, 1);
            products.splice(productIndex, 0, action.productsResult);

            return {
                products: products,
                productTypes: state.productTypes,
                productDeliveryTimes: state.productDeliveryTimes,
                properties: state.properties,
                bookingConditions: state.bookingConditions,
                legalEntities: state.legalEntities,
                sites: state.sites,
                invoiceProductTypes: state.invoiceProductTypes
            };
        default:
            return state;
    }
}
